module.exports = __webpack_public_path__ + "static/media/19ESCAP3.d9bcc45c.jpg";